var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { takeEvery, put, select, call, fork } from 'redux-saga/effects';
import * as A from './actions';
import { selectForm, selectFormMounted, selectCurrentForm, mapFreeFormStateKeys } from './selectors';
import { replaceElement, updateElementProperty } from '../../services/utils/def.utils';
import { execFormulaAsync } from '../../services/utils/formula.utils';
import { mapElementDef } from '../../services/utils/raw.utils';
import { formatNavParams, XbpmContext, SCREENFLOW_END, FORM_DESTROYED } from '../../services';
import { XbpmBlockType, XbpmFormType } from '../../models';
import { isElementBlock } from '../../services/utils/_.utils';
var mapUpdateFormulaFrontData = function (initiator) {
    var formulaFrontRequest = initiator.frontFormulas.formulaFrontRequest;
    return execFormulaAsync(formulaFrontRequest, initiator, false, false);
};
var getFormLogger = function (data) {
    return XbpmContext.getContext().logger.getFormLogger({
        applicationCode: "" + [data.applicationGroup, data.applicationCode].filter(function (it) { return !!it; }).join('.') + (data.applicationVersion ? "_" + data.applicationVersion : ''),
        formCode: data.taskDefinitionKey,
        processId: data.processInstanceId,
    });
};
var getFormEnv = function (data) { return ({ formLogger: getFormLogger(data) }); };
var getActionInitiatorParams = function (initiator) {
    var blockCode = isElementBlock(initiator)
        ? initiator.kind === XbpmBlockType.TABLE_ROW
            ? initiator.parent.code
            : initiator.code
        : initiator.block.code;
    var buttonCode = isElementBlock(initiator) ? null : initiator.code;
    return { blockCode: blockCode, buttonCode: buttonCode };
};
//
export function loadFormSuccessTask(processInstanceId, taskDefinitionKey, result) {
    var def;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                def = mapElementDef(getFormEnv(result), result);
                return [4 /*yield*/, put(A.loadSuccessAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, def: def }))];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
// load form
function loadFormWorker(_a) {
    var _b, apiService, navService, storeNavigationParams, processInstanceId, taskDefinitionKey, modalFormCode, _c, force, isNotLoaded, pathParams, result, resProcessInstanceId, resTaskDefinitionKey, isMounted, error_1;
    var payload = _a.payload;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _b = XbpmContext.getContext(), apiService = _b.apiService, navService = _b.navService, storeNavigationParams = _b.storeNavigationParams;
                processInstanceId = payload.processInstanceId, taskDefinitionKey = payload.taskDefinitionKey, modalFormCode = payload.modalFormCode, _c = payload.force, force = _c === void 0 ? false : _c;
                storeNavigationParams(payload);
                return [4 /*yield*/, select(selectForm(processInstanceId, taskDefinitionKey, null))];
            case 1:
                isNotLoaded = !(_d.sent());
                if (!(force || isNotLoaded)) return [3 /*break*/, 9];
                _d.label = 2;
            case 2:
                _d.trys.push([2, 6, , 8]);
                pathParams = { processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey };
                return [4 /*yield*/, call(apiService.fetchForm, pathParams)];
            case 3:
                result = _d.sent();
                resProcessInstanceId = result.processInstanceId;
                resTaskDefinitionKey = result.taskDefinitionKey;
                return [4 /*yield*/, select(selectFormMounted)];
            case 4:
                isMounted = _d.sent();
                if (isMounted &&
                    (modalFormCode || resProcessInstanceId !== processInstanceId || resTaskDefinitionKey !== taskDefinitionKey)) {
                    navService.navigate({
                        $kind: 'task',
                        processInstanceId: resProcessInstanceId,
                        taskDefinitionKey: resTaskDefinitionKey,
                    }, true);
                }
                return [4 /*yield*/, fork(loadFormSuccessTask, resProcessInstanceId, resTaskDefinitionKey, result)];
            case 5:
                _d.sent();
                return [3 /*break*/, 8];
            case 6:
                error_1 = _d.sent();
                return [4 /*yield*/, put(A.loadErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, error: error_1 }))];
            case 7:
                _d.sent();
                return [3 /*break*/, 8];
            case 8: return [3 /*break*/, 11];
            case 9: return [4 /*yield*/, put(A.changeMarkerAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode }))];
            case 10:
                _d.sent();
                _d.label = 11;
            case 11: return [2 /*return*/];
        }
    });
}
// load action form
function loadActFormWorker(_a) {
    var _b, apiService, navService, storeNavigationParams, emit, actionParams, pathParams, result, applicationGroup, applicationCode, applicationVersion, freeFormCode, processInstanceId, taskDefinitionKey, isFreeForm, keys, navParams, error_2;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = XbpmContext.getContext(), apiService = _b.apiService, navService = _b.navService, storeNavigationParams = _b.storeNavigationParams, emit = _b.emit;
                storeNavigationParams(payload);
                actionParams = payload.actionParams, pathParams = __rest(payload, ["actionParams"]);
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, , 8]);
                return [4 /*yield*/, call(apiService.fetchActForm, pathParams, actionParams)];
            case 2:
                result = _c.sent();
                if (!result) return [3 /*break*/, 4];
                applicationGroup = result.applicationGroup, applicationCode = result.applicationCode, applicationVersion = result.applicationVersion, freeFormCode = result.freeFormCode;
                processInstanceId = result.processInstanceId, taskDefinitionKey = result.taskDefinitionKey;
                isFreeForm = result.taskDefinitionType === XbpmFormType.FREE && !result.processInstanceId;
                if (isFreeForm) {
                    keys = mapFreeFormStateKeys({
                        applicationGroup: applicationGroup,
                        applicationCode: applicationCode,
                        applicationVersion: applicationVersion,
                        freeFormCode: freeFormCode,
                    });
                    processInstanceId = keys.processInstanceId;
                    taskDefinitionKey = keys.taskDefinitionKey;
                }
                return [4 /*yield*/, fork(loadFormSuccessTask, processInstanceId, taskDefinitionKey, result)];
            case 3:
                _c.sent();
                navParams = !isFreeForm
                    ? { $kind: 'task', processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey }
                    : {
                        $kind: 'free',
                        applicationGroup: applicationGroup,
                        applicationCode: applicationCode,
                        applicationVersion: applicationVersion,
                        freeFormCode: freeFormCode,
                        queryParams: actionParams,
                    };
                navService.navigate(navParams, true);
                return [3 /*break*/, 5];
            case 4:
                emit(SCREENFLOW_END);
                throw null;
            case 5: return [3 /*break*/, 8];
            case 6:
                error_2 = _c.sent();
                return [4 /*yield*/, put(A.loadErrorAction({ processInstanceId: null, taskDefinitionKey: null, error: error_2 }))];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
// load free form
function loadFreeFormWorker(_a) {
    var _b, apiService, storeNavigationParams, _c, processInstanceId, taskDefinitionKey, $kind, applicationGroup, applicationCode, applicationVersion, freeFormCode, force, queryParams, navigationParams, result, error_3;
    var payload = _a.payload;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                _b = XbpmContext.getContext(), apiService = _b.apiService, storeNavigationParams = _b.storeNavigationParams;
                _c = mapFreeFormStateKeys(payload), processInstanceId = _c.processInstanceId, taskDefinitionKey = _c.taskDefinitionKey;
                $kind = payload.$kind, applicationGroup = payload.applicationGroup, applicationCode = payload.applicationCode, applicationVersion = payload.applicationVersion, freeFormCode = payload.freeFormCode, force = payload.force, queryParams = __rest(payload, ["$kind", "applicationGroup", "applicationCode", "applicationVersion", "freeFormCode", "force"]);
                navigationParams = {
                    $kind: $kind,
                    applicationGroup: applicationGroup,
                    applicationCode: applicationCode,
                    applicationVersion: applicationVersion,
                    freeFormCode: freeFormCode,
                    force: force,
                    queryParams: queryParams,
                };
                storeNavigationParams(navigationParams);
                _d.label = 1;
            case 1:
                _d.trys.push([1, 4, , 6]);
                return [4 /*yield*/, call(apiService.fetchFreeForm, payload)];
            case 2:
                result = _d.sent();
                return [4 /*yield*/, fork(loadFormSuccessTask, processInstanceId, taskDefinitionKey, result)];
            case 3:
                _d.sent();
                return [3 /*break*/, 6];
            case 4:
                error_3 = _d.sent();
                return [4 /*yield*/, put(A.loadErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, error: error_3 }))];
            case 5:
                _d.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
// load modal form
function loadModalFormWorker(_a) {
    var _b, apiService, navService, processInstanceId, taskDefinitionKey, initiator, button, buttonCode, modalFormCode, initiatorId, state, frontData, pathParams, result, error_4;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = XbpmContext.getContext(), apiService = _b.apiService, navService = _b.navService;
                processInstanceId = payload.processInstanceId, taskDefinitionKey = payload.taskDefinitionKey, initiator = payload.initiator;
                button = initiator;
                buttonCode = button.code;
                modalFormCode = button.frontOptions.modalFormCode;
                initiatorId = initiator.id;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, , 8]);
                return [4 /*yield*/, select()];
            case 2:
                state = _c.sent();
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, initiator)];
            case 3:
                frontData = _c.sent();
                pathParams = {
                    processInstanceId: processInstanceId,
                    taskDefinitionKey: taskDefinitionKey,
                    blockCode: initiator.block.code,
                    buttonCode: buttonCode,
                    modalFormCode: modalFormCode,
                };
                return [4 /*yield*/, call(apiService.fetchModalForm, pathParams, frontData)];
            case 4:
                result = _c.sent();
                if (selectFormMounted(state)) {
                    navService.navigate({
                        $kind: 'task',
                        processInstanceId: processInstanceId,
                        taskDefinitionKey: taskDefinitionKey,
                        modalFormCode: modalFormCode,
                        initiatorCode: buttonCode,
                    });
                }
                return [4 /*yield*/, put(A.loadModalSuccessAction({
                        processInstanceId: processInstanceId,
                        taskDefinitionKey: taskDefinitionKey,
                        modalFormCode: modalFormCode,
                        initiatorId: initiatorId,
                        def: mapElementDef(getFormEnv(result), result),
                    }))];
            case 5:
                _c.sent();
                return [3 /*break*/, 8];
            case 6:
                error_4 = _c.sent();
                return [4 /*yield*/, put(A.loadModalErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode, initiatorId: initiatorId, error: error_4 }))];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
//
function closeChildFormWorker(_a) {
    var _b, apiService, navService, processInstanceId, taskDefinitionKey, modalFormCode, initiator, def, state, frontData, pathParams, result, error_5;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = XbpmContext.getContext(), apiService = _b.apiService, navService = _b.navService;
                processInstanceId = payload.processInstanceId, taskDefinitionKey = payload.taskDefinitionKey, modalFormCode = payload.modalFormCode, initiator = payload.initiator, def = payload.def;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 6, , 8]);
                return [4 /*yield*/, select()];
            case 2:
                state = _c.sent();
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, initiator)];
            case 3:
                frontData = _c.sent();
                pathParams = {
                    processInstanceId: processInstanceId,
                    taskDefinitionKey: taskDefinitionKey,
                    blockCode: initiator.block.code,
                    buttonCode: initiator.code,
                    modalFormCode: modalFormCode,
                };
                return [4 /*yield*/, call(apiService.closeModalForm, pathParams, frontData)];
            case 4:
                result = _c.sent();
                if (selectFormMounted(state)) {
                    navService.navigate({
                        $kind: 'task',
                        processInstanceId: processInstanceId,
                        taskDefinitionKey: taskDefinitionKey,
                    });
                }
                return [4 /*yield*/, put(A.closeModalSuccessAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode, def: def, result: result }))];
            case 5:
                _c.sent();
                return [3 /*break*/, 8];
            case 6:
                error_5 = _c.sent();
                return [4 /*yield*/, put(A.closeModalErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode, error: error_5 }))];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
// save form
function saveFormWorker(_a) {
    var apiService, processInstanceId, taskDefinitionKey, initiator, def, frontData, pathParams, error_6;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                processInstanceId = payload.processInstanceId, taskDefinitionKey = payload.taskDefinitionKey, initiator = payload.initiator, def = payload.def;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, initiator)];
            case 2:
                frontData = _b.sent();
                pathParams = {
                    processInstanceId: processInstanceId,
                    taskDefinitionKey: taskDefinitionKey,
                    blockCode: initiator.block.code,
                    buttonCode: initiator.code,
                };
                return [4 /*yield*/, call(apiService.saveForm, pathParams, frontData)];
            case 3:
                _b.sent();
                return [4 /*yield*/, put(A.saveSuccessAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, def: def }))];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                error_6 = _b.sent();
                return [4 /*yield*/, put(A.saveErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, error: error_6 }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
// save free form
function saveFreeFormWorker(_a) {
    var apiService, initiator, def, params, _b, processInstanceId, taskDefinitionKey, frontData, pathParams, error_7;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                initiator = payload.initiator, def = payload.def, params = __rest(payload, ["initiator", "def"]);
                _b = mapFreeFormStateKeys(payload), processInstanceId = _b.processInstanceId, taskDefinitionKey = _b.taskDefinitionKey;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, initiator)];
            case 2:
                frontData = _c.sent();
                pathParams = __assign(__assign({}, params), { blockCode: initiator.block.code, buttonCode: initiator.code });
                return [4 /*yield*/, call(apiService.saveFreeForm, pathParams, frontData)];
            case 3:
                _c.sent();
                return [4 /*yield*/, put(A.saveSuccessAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, def: def }))];
            case 4:
                _c.sent();
                return [3 /*break*/, 7];
            case 5:
                error_7 = _c.sent();
                return [4 /*yield*/, put(A.saveErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, error: error_7 }))];
            case 6:
                _c.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
// next form
function nextFormWorker(_a) {
    var _b, apiService, navService, storeNavigationParams, emit, processInstanceId, taskDefinitionKey, initiator, def, state, frontData, pathParams, result, nextParams, params, error_8;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _b = XbpmContext.getContext(), apiService = _b.apiService, navService = _b.navService, storeNavigationParams = _b.storeNavigationParams, emit = _b.emit;
                processInstanceId = payload.processInstanceId, taskDefinitionKey = payload.taskDefinitionKey, initiator = payload.initiator, def = payload.def;
                return [4 /*yield*/, select()];
            case 1:
                state = _c.sent();
                _c.label = 2;
            case 2:
                _c.trys.push([2, 6, , 8]);
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, initiator)];
            case 3:
                frontData = _c.sent();
                pathParams = __assign({ processInstanceId: processInstanceId,
                    taskDefinitionKey: taskDefinitionKey }, getActionInitiatorParams(initiator));
                return [4 /*yield*/, call(apiService.nextForm, pathParams, frontData)];
            case 4:
                result = _c.sent();
                if (!result) {
                    emit(SCREENFLOW_END);
                }
                nextParams = {
                    processInstanceId: result ? result.processInstanceId : processInstanceId,
                    taskDefinitionKey: result ? result.taskDefinitionKey : taskDefinitionKey,
                };
                return [4 /*yield*/, put(A.nextSuccessAction(__assign({ def: result ? mapElementDef(getFormEnv(result), result) : def }, nextParams)))];
            case 5:
                _c.sent();
                if (!!result && selectFormMounted(state)) {
                    params = void 0;
                    if (result.taskDefinitionType === 'FREE') {
                        params = {
                            $kind: 'free',
                            applicationGroup: result.applicationGroup,
                            applicationCode: result.applicationCode,
                            applicationVersion: result.applicationVersion,
                            freeFormCode: result.freeFormCode,
                        };
                    }
                    else {
                        params = __assign({ $kind: 'task' }, nextParams);
                    }
                    storeNavigationParams(params);
                    navService.navigate(params, true);
                }
                return [3 /*break*/, 8];
            case 6:
                error_8 = _c.sent();
                return [4 /*yield*/, put(A.nextErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, error: error_8 }))];
            case 7:
                _c.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
// refresh form
function refreshFormWorker(_a) {
    var apiService, processInstanceId, taskDefinitionKey, modalFormCode, initiator, def, formulaFrontFindBlock, updatedBlocks, frontData, form, _i, updatedBlocks_1, updatedBlock, pathParams, result, error_9;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                processInstanceId = payload.processInstanceId, taskDefinitionKey = payload.taskDefinitionKey, modalFormCode = payload.modalFormCode, initiator = payload.initiator;
                def = payload.def;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 10, , 12]);
                formulaFrontFindBlock = initiator.frontFormulas.formulaFrontFindBlock;
                return [4 /*yield*/, call(execFormulaAsync, formulaFrontFindBlock, initiator, false, false)];
            case 2:
                updatedBlocks = (_b.sent());
                updatedBlocks = Array.isArray(updatedBlocks) ? updatedBlocks : [updatedBlocks];
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, initiator)];
            case 3:
                frontData = _b.sent();
                return [4 /*yield*/, select(selectCurrentForm)];
            case 4:
                form = _b.sent();
                _i = 0, updatedBlocks_1 = updatedBlocks;
                _b.label = 5;
            case 5:
                if (!(_i < updatedBlocks_1.length)) return [3 /*break*/, 8];
                updatedBlock = updatedBlocks_1[_i];
                pathParams = __assign(__assign({ processInstanceId: processInstanceId, taskDefinitionKey: modalFormCode || taskDefinitionKey }, getActionInitiatorParams(initiator)), { targetBlockCode: updatedBlock.kind === XbpmBlockType.TABLE_ROW ? updatedBlock.block.code : updatedBlock.code });
                return [4 /*yield*/, call(apiService.updateBlock, pathParams, frontData)];
            case 6:
                result = _b.sent();
                if (updatedBlock.kind === XbpmBlockType.TABLE_ROW || updatedBlock.kind === XbpmBlockType.TAB) {
                    def = updateElementProperty(updatedBlock.parent.id, 'lastChanged', Date.now(), def);
                }
                def = replaceElement(def, updatedBlock.id, result, getFormEnv(form));
                _b.label = 7;
            case 7:
                _i++;
                return [3 /*break*/, 5];
            case 8: return [4 /*yield*/, put(A.refreshSuccessAction({
                    processInstanceId: processInstanceId,
                    taskDefinitionKey: taskDefinitionKey,
                    modalFormCode: modalFormCode,
                    def: def,
                }))];
            case 9:
                _b.sent();
                return [3 /*break*/, 12];
            case 10:
                error_9 = _b.sent();
                // const error = isCancelation(err) ? null : 'Ошибка при обработке запроса! Возможно не найден блок по формуле formulaFindBlock.\n' + err;
                return [4 /*yield*/, put(A.refreshErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode, error: error_9 }))];
            case 11:
                // const error = isCancelation(err) ? null : 'Ошибка при обработке запроса! Возможно не найден блок по формуле formulaFindBlock.\n' + err;
                _b.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
// refresh free form
function refreshFreeFormWorker(_a) {
    var apiService, initiator, defOld, params, def, _b, processInstanceId, taskDefinitionKey, formulaFrontFindBlock, updatedBlocks, frontData, form, _i, updatedBlocks_2, updatedBlock, pathParams, result, error_10;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                initiator = payload.initiator, defOld = payload.def, params = __rest(payload, ["initiator", "def"]);
                def = payload.def;
                _b = mapFreeFormStateKeys(payload), processInstanceId = _b.processInstanceId, taskDefinitionKey = _b.taskDefinitionKey;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 10, , 12]);
                formulaFrontFindBlock = initiator.frontFormulas.formulaFrontFindBlock;
                return [4 /*yield*/, call(execFormulaAsync, formulaFrontFindBlock, initiator, false, false)];
            case 2:
                updatedBlocks = (_c.sent());
                updatedBlocks = Array.isArray(updatedBlocks) ? updatedBlocks : [updatedBlocks];
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, initiator)];
            case 3:
                frontData = _c.sent();
                return [4 /*yield*/, select(selectCurrentForm)];
            case 4:
                form = _c.sent();
                _i = 0, updatedBlocks_2 = updatedBlocks;
                _c.label = 5;
            case 5:
                if (!(_i < updatedBlocks_2.length)) return [3 /*break*/, 8];
                updatedBlock = updatedBlocks_2[_i];
                pathParams = __assign(__assign(__assign({}, params), getActionInitiatorParams(initiator)), { targetBlockCode: updatedBlock.kind === XbpmBlockType.TABLE_ROW ? updatedBlock.block.code : updatedBlock.code });
                return [4 /*yield*/, call(apiService.updateFreeFormBlock, pathParams, frontData)];
            case 6:
                result = _c.sent();
                if (updatedBlock.kind === XbpmBlockType.TABLE_ROW || updatedBlock.kind === XbpmBlockType.TAB) {
                    def = updateElementProperty(updatedBlock.parent.id, 'lastChanged', Date.now(), def);
                }
                def = replaceElement(def, updatedBlock.id, result, getFormEnv(form));
                _c.label = 7;
            case 7:
                _i++;
                return [3 /*break*/, 5];
            case 8: return [4 /*yield*/, put(A.refreshSuccessAction({
                    processInstanceId: processInstanceId,
                    taskDefinitionKey: taskDefinitionKey,
                    modalFormCode: null,
                    def: def,
                }))];
            case 9:
                _c.sent();
                return [3 /*break*/, 12];
            case 10:
                error_10 = _c.sent();
                // const error = isCancelation(err) ? null : 'Ошибка при обработке запроса! Возможно не найден блок по формуле formulaFindBlock.\n' + err;
                return [4 /*yield*/, put(A.refreshErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: null, error: error_10 }))];
            case 11:
                // const error = isCancelation(err) ? null : 'Ошибка при обработке запроса! Возможно не найден блок по формуле formulaFindBlock.\n' + err;
                _c.sent();
                return [3 /*break*/, 12];
            case 12: return [2 /*return*/];
        }
    });
}
// add form block
function addBlockTask(processInstanceId, taskDefinitionKey, modalFormCode, button, mapReq) {
    var formulaFrontFindPlace, placeDataItems_1, frontData_1, results_1, form_1, actionPayload, error_11;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                formulaFrontFindPlace = button.frontFormulas.formulaFrontFindPlace;
                return [4 /*yield*/, call(execFormulaAsync, formulaFrontFindPlace, button, false, false)];
            case 1:
                placeDataItems_1 = (_a.sent());
                if (!Array.isArray(placeDataItems_1[0])) {
                    placeDataItems_1 = [placeDataItems_1];
                }
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, button)];
            case 2:
                frontData_1 = _a.sent();
                return [4 /*yield*/, call(function () { return Promise.all(placeDataItems_1.map(mapReq(frontData_1))); })];
            case 3:
                results_1 = _a.sent();
                return [4 /*yield*/, select(selectCurrentForm)];
            case 4:
                form_1 = _a.sent();
                actionPayload = {
                    processInstanceId: processInstanceId,
                    taskDefinitionKey: taskDefinitionKey,
                    modalFormCode: modalFormCode,
                    items: placeDataItems_1.map(function (_a, i) {
                        var inputBlock = _a[0], prevBlock = _a[1];
                        return ({
                            inputBlockId: inputBlock.id,
                            prevBlockId: prevBlock && prevBlock.id,
                            newBlock: mapElementDef(getFormEnv(form_1), results_1[i], inputBlock),
                        });
                    }),
                };
                return [4 /*yield*/, put(A.addBlocksSuccessAction(actionPayload))];
            case 5:
                _a.sent();
                return [3 /*break*/, 8];
            case 6:
                error_11 = _a.sent();
                // const error = isCancelation(err) ? null : 'Ошибка при обработке запроса! Возможно не найден блок для вставки нового блока по формуле formulaFindPlace.\n' + err;
                return [4 /*yield*/, put(A.addBlockErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode, error: error_11 }))];
            case 7:
                // const error = isCancelation(err) ? null : 'Ошибка при обработке запроса! Возможно не найден блок для вставки нового блока по формуле formulaFindPlace.\n' + err;
                _a.sent();
                return [3 /*break*/, 8];
            case 8: return [2 /*return*/];
        }
    });
}
function addFormBlockWorker(_a) {
    var apiService, processInstanceId, taskDefinitionKey, modalFormCode, initiator, button;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                processInstanceId = payload.processInstanceId, taskDefinitionKey = payload.taskDefinitionKey, modalFormCode = payload.modalFormCode, initiator = payload.initiator;
                button = initiator;
                return [4 /*yield*/, fork(addBlockTask, processInstanceId, taskDefinitionKey, modalFormCode, button, function (frontData) { return function (placeData) {
                        var pathParams = __assign(__assign({ processInstanceId: processInstanceId, taskDefinitionKey: modalFormCode || taskDefinitionKey }, getActionInitiatorParams(initiator)), { targetBlockCode: placeData[2] || button.frontOptions.templateBlockCode });
                        return apiService.addBlock(pathParams, frontData);
                    }; })];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
// add free form block
function addFreeFormBlockWorker(_a) {
    var apiService, initiator, params, _b, processInstanceId, taskDefinitionKey, button;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                initiator = payload.initiator, params = __rest(payload, ["initiator"]);
                _b = mapFreeFormStateKeys(payload), processInstanceId = _b.processInstanceId, taskDefinitionKey = _b.taskDefinitionKey;
                button = initiator;
                return [4 /*yield*/, fork(addBlockTask, processInstanceId, taskDefinitionKey, null, button, function (frontData) { return function (placeData) {
                        var pathParams = __assign(__assign(__assign({}, params), getActionInitiatorParams(initiator)), { targetBlockCode: placeData[2] || button.frontOptions.templateBlockCode });
                        return apiService.addFreeFormBlock(pathParams, frontData);
                    }; })];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
// remove form block
function removeBlockTask(processInstanceId, taskDefinitionKey, modalFormCode, button, mapReq) {
    var formulaFrontFindBlock, blocks_1, frontData_2, error_12;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 7]);
                formulaFrontFindBlock = button.frontFormulas.formulaFrontFindBlock;
                return [4 /*yield*/, call(execFormulaAsync, formulaFrontFindBlock, button, false, false)];
            case 1:
                blocks_1 = (_a.sent());
                if (!Array.isArray(blocks_1)) {
                    blocks_1 = [blocks_1];
                }
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, button)];
            case 2:
                frontData_2 = _a.sent();
                return [4 /*yield*/, call(function () { return Promise.all(blocks_1.map(mapReq(frontData_2))); })];
            case 3:
                _a.sent();
                return [4 /*yield*/, put(A.removeBlocksSuccessAction({
                        processInstanceId: processInstanceId,
                        taskDefinitionKey: taskDefinitionKey,
                        modalFormCode: modalFormCode,
                        blockIds: blocks_1.map(function (b) { return b.id; }),
                    }))];
            case 4:
                _a.sent();
                return [3 /*break*/, 7];
            case 5:
                error_12 = _a.sent();
                // const error = isCancelation(err) ? null : 'Ошибка при обработке запроса! Возможно не найден блок для вставки нового блока по формуле formulaFindPlace.\n' + err;
                return [4 /*yield*/, put(A.removeBlockErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode, error: error_12 }))];
            case 6:
                // const error = isCancelation(err) ? null : 'Ошибка при обработке запроса! Возможно не найден блок для вставки нового блока по формуле formulaFindPlace.\n' + err;
                _a.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function removeFormBlockWorker(_a) {
    var apiService, processInstanceId, taskDefinitionKey, modalFormCode, initiator;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                processInstanceId = payload.processInstanceId, taskDefinitionKey = payload.taskDefinitionKey, modalFormCode = payload.modalFormCode, initiator = payload.initiator;
                return [4 /*yield*/, fork(removeBlockTask, processInstanceId, taskDefinitionKey, modalFormCode, initiator, function (frontData) { return function () {
                        var pathParams = __assign({ processInstanceId: processInstanceId, taskDefinitionKey: modalFormCode || taskDefinitionKey }, getActionInitiatorParams(initiator));
                        return apiService.removeBlock(pathParams, frontData);
                    }; })];
            case 1:
                _b.sent();
                return [2 /*return*/];
        }
    });
}
// remove free form block
function removeFreeFormBlockWorker(_a) {
    var apiService, initiator, params, _b, processInstanceId, taskDefinitionKey;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                initiator = payload.initiator, params = __rest(payload, ["initiator"]);
                _b = mapFreeFormStateKeys(payload), processInstanceId = _b.processInstanceId, taskDefinitionKey = _b.taskDefinitionKey;
                return [4 /*yield*/, fork(removeBlockTask, processInstanceId, taskDefinitionKey, null, initiator, function (frontData) { return function () {
                        var pathParams = __assign(__assign({}, params), getActionInitiatorParams(initiator));
                        return apiService.removeFreeFormBlock(pathParams, frontData);
                    }; })];
            case 1:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
// form click
function clickRequestWorker(_a) {
    var apiService, processInstanceId, taskDefinitionKey, modalFormCode, initiator, frontData, initiatorId, pathParams, result, error_13;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                apiService = XbpmContext.getContext().apiService;
                processInstanceId = payload.processInstanceId, taskDefinitionKey = payload.taskDefinitionKey, modalFormCode = payload.modalFormCode, initiator = payload.initiator;
                _b.label = 1;
            case 1:
                _b.trys.push([1, 5, , 7]);
                return [4 /*yield*/, call(mapUpdateFormulaFrontData, initiator)];
            case 2:
                frontData = _b.sent();
                initiatorId = initiator.id;
                pathParams = __assign({ processInstanceId: processInstanceId, taskDefinitionKey: modalFormCode || taskDefinitionKey }, getActionInitiatorParams(initiator));
                return [4 /*yield*/, call(apiService.click, pathParams, frontData)];
            case 3:
                result = _b.sent();
                return [4 /*yield*/, put(A.clickRequestSuccessAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode, initiatorId: initiatorId, result: result }))];
            case 4:
                _b.sent();
                return [3 /*break*/, 7];
            case 5:
                error_13 = _b.sent();
                return [4 /*yield*/, put(A.clickRequestErrorAction({ processInstanceId: processInstanceId, taskDefinitionKey: taskDefinitionKey, modalFormCode: modalFormCode, error: error_13 }))];
            case 6:
                _b.sent();
                return [3 /*break*/, 7];
            case 7: return [2 /*return*/];
        }
    });
}
function cancelFormWorker() {
    return __generator(this, function (_a) {
        XbpmContext.getContext().navService.back();
        return [2 /*return*/];
    });
}
function navigationWorker(_a) {
    var payload = _a.payload;
    return __generator(this, function (_b) {
        XbpmContext.getContext().navService.navigate(payload);
        return [2 /*return*/];
    });
}
function navigationWithFormulaWorker(_a) {
    var result, params;
    var payload = _a.payload;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, call(mapUpdateFormulaFrontData, payload.initiator)];
            case 1:
                result = _b.sent();
                params = formatNavParams(result);
                if (!params) return [3 /*break*/, 3];
                return [4 /*yield*/, put(A.navigateWithParamsAction(params))];
            case 2:
                _b.sent();
                _b.label = 3;
            case 3: return [2 /*return*/];
        }
    });
}
function formMountWorker(_a) {
    var _b, storeNavigationParams, emit;
    var payload = _a.payload;
    return __generator(this, function (_c) {
        if (!payload.mount) {
            _b = XbpmContext.getContext(), storeNavigationParams = _b.storeNavigationParams, emit = _b.emit;
            storeNavigationParams(null);
            emit(FORM_DESTROYED);
        }
        return [2 /*return*/];
    });
}
export default (function () { return [
    takeEvery(A.FORM_LOAD, loadFormWorker),
    takeEvery(A.FORM_ACT_LOAD, loadActFormWorker),
    takeEvery(A.FORM_FREE_LOAD, loadFreeFormWorker),
    takeEvery(A.FORM_MODAL_LOAD, loadModalFormWorker),
    takeEvery(A.FORM_MODAL_CLOSE, closeChildFormWorker),
    takeEvery(A.FORM_SAVE, saveFormWorker),
    takeEvery(A.FORM_FREE_SAVE, saveFreeFormWorker),
    takeEvery(A.FORM_NEXT, nextFormWorker),
    takeEvery(A.FORM_REFRESH, refreshFormWorker),
    takeEvery(A.FORM_FREE_REFRESH, refreshFreeFormWorker),
    takeEvery(A.FORM_ADD_BLOCK, addFormBlockWorker),
    takeEvery(A.FORM_FREE_ADD_BLOCK, addFreeFormBlockWorker),
    takeEvery(A.FORM_REMOVE_BLOCK, removeFormBlockWorker),
    takeEvery(A.FORM_FREE_REMOVE_BLOCK, removeFreeFormBlockWorker),
    takeEvery(A.FORM_CLICK_REQUEST, clickRequestWorker),
    takeEvery(A.FORM_CANCEL, cancelFormWorker),
    takeEvery(A.FORM_MODAL_CANCEL, cancelFormWorker),
    takeEvery(A.FORM_NAVIGATE_WITH_INITIATOR, navigationWithFormulaWorker),
    takeEvery(A.FORM_NAVIGATE_WITH_PARAMS, navigationWorker),
    takeEvery(A.FORM_MOUNT, formMountWorker),
]; });
//# sourceMappingURL=sagas.js.map